function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7144 30.1909V30.0646V29.054H2.59742V15.7902L5.19483 8.21092H7.5325H9.87018H22.8573H25.1949H27.5326L29.7404 14.527C30.0001 14.527 32.0781 14.527 32.0781 14.527L29.2209 5.68448H25.3248V0H7.14289V5.68448H3.24677L0 15.1586V31.5805H15.9741C15.8442 31.2015 15.7144 30.6962 15.7144 30.1909ZM10 2.9054H22.3378V5.68448H10V2.9054Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M37.4026 14.5273H30.6493C25.5843 14.5273 21.5583 18.5696 21.5583 23.4962V23.6225H22.2077C22.8571 23.6225 23.5064 23.7488 24.1558 23.8752C24.1558 23.7488 24.1558 23.6225 24.1558 23.4962C24.1558 19.9592 27.1428 17.0538 30.6493 17.0538H37.4026V24.0015C37.1428 27.2858 34.2857 29.9386 30.7792 29.9386C29.9999 29.9386 29.2207 29.8123 28.5714 29.5596C28.5714 29.686 28.5714 29.686 28.5714 29.8123C28.5714 30.5702 28.4415 31.3281 28.0519 32.0861C28.961 32.3387 29.7402 32.465 30.7792 32.465C35.5844 32.465 39.6104 28.8017 40 24.2541V17.0538V14.5273H37.4026Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0129 25.6422C25.7142 24.2527 24.0258 23.6211 22.2076 23.6211H18.3115H15.7141V26.1475V30.0635V30.1898V30.3162C15.9739 33.4742 18.7011 36.0006 22.0778 36.0006C25.5843 36.0006 28.5713 33.2216 28.5713 29.8109C28.7012 28.295 28.0518 26.7791 27.0129 25.6422ZM22.0778 33.4742C20.1297 33.4742 18.4414 31.9583 18.3115 30.0635V26.1475H22.2076C24.4155 26.1475 26.1038 27.7897 25.9739 29.6845C25.9739 31.832 24.1557 33.4742 22.0778 33.4742Z",
  fill: "currentColor"
});

var SvgIcProductCatSlVhisMedical = function SvgIcProductCatSlVhisMedical(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcProductCatSlVhisMedical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_product_cat_sl_vhis_medical.ced76577.svg";
export { ForwardRef as ReactComponent };